<main class="main">
  <div class="container-wrapper d-flex flex-column min-vh-100">
    <skipper/>
    <web-patient-header/>
    <div id="maincontent" class="d-flex flex-column overflow-auto justify-content-start flex-grow-1 flex-shrink-1">
        <router-outlet/>
    </div>
    <web-patient-footer/>
  </div>
</main>